@if (totalActiveParseRequests() > 0) {
  <div
    class="rounded-md outline outline-1 outline-offset-[-1px] p-4 bg-secondary-soft dark:bg-secondary-soft-darkmode outline-secondary-soft-outline dark:outline-secondary-soft-outline-darkmode w-full"
  >
    <div class="flex gap-3 items-center">
      <ui-badge color="error" mode="filled" rounded="full" class="flex-none">{{
        totalActiveParseRequests()
      }}</ui-badge>
      <span
        class="flex-1 text-sm font-semibold text-on-secondary-soft dark:text-on-secondary-soft-darkmode leading-5"
      >
        {{ 'cockpit.dashboard.parseRequestAlert.title' | transloco }}
      </span>
      <ui-button
        mode="outlined"
        size="small"
        class="flex-none"
        [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
        >{{ 'cockpit.dashboard.parseRequestAlert.buttonText' | transloco }}</ui-button
      >
    </div>
  </div>
}
